import { forwardRef, type Ref, type SVGProps } from "react";
const IconShieldFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M27.973 8.428c-.037-.791-.598-1.432-1.356-1.658C25.219 6.352 22.959 5.642 21.5 5 19.26 4.015 16 2 16 2s-3.26 2.015-5.5 3c-1.46.642-3.719 1.352-5.117 1.77-.758.226-1.318.867-1.355 1.657-.09 1.909-.034 5.788 1.293 10.698 1.694 6.27 7.89 9.608 9.983 10.574.446.206.945.206 1.392 0 2.092-.966 8.289-4.303 9.983-10.574 1.327-4.91 1.383-8.789 1.294-10.697"
    />
  </svg>
);
const ForwardRef = forwardRef(IconShieldFilledSVG);
ForwardRef.displayName = "IconShieldFilled";
export { ForwardRef as IconShieldFilled };
